import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { forbiddenNameValidator } from '../../../../settings/utils/forms.utils';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent {

  form = this.formBuilder.group({
    name: ['', [Validators.required, forbiddenNameValidator(this.data)]]
  })
  constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private _translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {
  }

  get errorLabel(): string {
    const error = this.form.controls.name.errors;
    if (error?.['forbiddenName']) {
      return this._translate.instant('FIELD_ERROR.NAME_ALREADY_EXISTS');
    }

    return this._translate.instant('FIELD_ERROR.NAME');
  }

  onSubmit() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.name);
    }
  }
}
